import {ChangeDetectionStrategy, Component, effect, Injectable, Signal, viewChild} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {TranslateModule} from "@ngx-translate/core";
import {firstValueFrom, Observable} from "rxjs";
import {InvitasjonerDatatjeneste} from "felles-ng2/tjenester/datalager/InvitasjonerDatatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeInvitasjonTilGodkjenningModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MedlemId} from "../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeNil} from "../../../../../felles-ng2/støttefunksjoner/nilsjekk";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {GruppeGodtaInvitasjonDialogKomponent} from "../../modale/gruppe-godta-invitasjon-dialog/gruppe-godta-invitasjon-dialog";
import {MatDialog} from "@angular/material/dialog";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";

const debug = initDebugger('GrupperListInvitasjonerKomponent');

@Component({
    selector: 'grupper-list-invitasjoner',
    templateUrl: 'grupper-list-invitasjoner.html',
    styleUrl: 'grupper-list-invitasjoner.scss',
    imports: [
        TranslateModule,
        MatTable,
        MatColumnDef,
        MatHeaderCell,
        MatCell,
        MatHeaderCellDef,
        MatCellDef,
        MatHeaderRow,
        MatRow,
        MatRowDef,
        MatHeaderRowDef,
        ReactiveFormsModule,
        MatSort,
        MatTableModule, MatSortModule, MatButton, MatIcon, FormaterPlainDatePipe, ZonedDateTimeSomPlainDatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperListInvitasjonerKomponent {
    static ajsSelector = 'grupperListInvitasjoner';


    invitertTil: Signal<GruppeInvitasjonTilGodkjenningModell[]>;
    invitertTilDataSource: MatTableDataSource<GruppeInvitasjonTilGodkjenningModell> = new MatTableDataSource<GruppeInvitasjonTilGodkjenningModell>();
    invitertTilSort = viewChild(MatSort);

    constructor(private avhengigheter: GrupperListInvitasjonerKomponentAvhengigheter, private navigasjon:Navigasjon, private matDialog: MatDialog) {

        this.invitertTil = toSignal(this.avhengigheter.invitasjoner(), {initialValue: []});


        effect(() => {
            this.invitertTilDataSource.data = this.invitertTil();
        });

        effect(() => {
            const sortInstance = this.invitertTilSort();
            if (sortInstance) {
                this.invitertTilDataSource.sort = sortInstance;
            }
        });
    }

    async godta(invitasjon: GruppeInvitasjonTilGodkjenningModell) {
        let dialog = GruppeGodtaInvitasjonDialogKomponent.vis(this.matDialog, invitasjon);
        const nyGruppe = await firstValueFrom(dialog.afterClosed(), {defaultValue: null});
        // vi vil ikke gå til den nye gruppa - de som har flere grupper å godkjenne syns det er veldig irriterende.
        // if (erIkkeNil(nyGruppe)) this.navigasjon.gåTilGruppe(nyGruppe.id);
    }

    async avslaa(invitasjon: GruppeInvitasjonTilGodkjenningModell) {
        await this.avhengigheter.avslåInvitasjon(invitasjon.id);
    }

}

@Injectable({providedIn: 'root'})
export class GrupperListInvitasjonerKomponentAvhengigheter {
    constructor(private invitasjonerDatatjeneste: InvitasjonerDatatjeneste) {
    }

    invitasjoner(): Observable<GruppeInvitasjonTilGodkjenningModell[]> {
        return this.invitasjonerDatatjeneste.invitasjonerTilGodkjenning();
    }

    avslåInvitasjon(id: MedlemId): Promise<any> {
        return this.invitasjonerDatatjeneste.avslåInvitasjonSomEksisterendeBruker(id);
    }
}
